export class BusinessRulesModel {
  BusinessRulesAPI: any;
  BusinessRulesListByID: any;
  RuleTypeListAPI: any;
  businessRuleTypeListDataAPI: any;
  businessRulesListDataAPI: any;
}
